import { atom } from "jotai";

export const loggedUserAtom = atom({
  loginEmail: "",
  password: "",
});

export const isLoginExpiredAtom = atom(false);
